module.exports = __webpack_public_path__ + "static/media/ocean-bg.0a9f3d5a.jpg";